import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

const SubContext = createContext(null);

export function SubscriptionProvider({ children }) {
  const { family } = useAuth();
  const [state, setState] = useState(null);

  const refresh = useCallback(async () => {
    if (!family) { setState(null); return; }
    try {
      const { data } = await api.get(`/families/${family.id}/subscription`);
      setState(data);
    } catch {
      setState(null);
    }
  }, [family]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SubContext.Provider value={{ ...state, refresh }}>
      {children}
    </SubContext.Provider>
  );
}

export function useSubscription() {
  const ctx = useContext(SubContext);
  return ctx || { quotas: null, usage: null, tier: "free", refresh: () => {} };
}
